module.exports = __webpack_public_path__ + "img/bitcoin2.74eadec3.png";